import { Input, HostListener, OnInit, OnChanges, SimpleChanges, Output, Component, ElementRef, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
  selector: 'dropdown-select',
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss'],
  host: { '(document:click)': 'onClick($event)' },
})
export class DropdownSelectComponent implements OnInit, OnChanges, AfterViewInit {

  // Inputs variables
  @Input() items: any[];
  @Input() image: string | null = null;
  @Input() tooltip: boolean = false;
  @Input() id: number = 0;

  @Input() set selected(value: any | null) {
    if (value !== null && value !== undefined) {
      const selected = (this.selected !== null && this.selected.key !== undefined) ? this.selected.key : this.selected;
      const newValue = value.key !== undefined ? value.key : value;
      if (this.selected === null || selected !== newValue) {
        this._selected = value;
        this.findSelected();
      }
    }
  }
  get selected(): any | null {
    return this._selected;
  }
  @Input() disabled: boolean;

  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onItemInit: EventEmitter<any> = new EventEmitter<any>();

  // Suscriptions
  private selectedWatch$: any;

  // Selected item
  public itemSelected: string | null;
  public itemImageSelected: string | null;
  // Dropdown open status
  public dropdownOpened: boolean = false;
  public random: number;
  private _selected: any | null = null;

  // Constructor
  constructor(private _eref: ElementRef) { }

  // On component init
  ngOnInit() {
    if (this.tooltip) this.random = Math.floor((Math.random() * 100) + 1);

    this.itemSelected = (this.items && this.items.length > 0) ? this.items[0].text : null;
    this.itemImageSelected = (this.items && this.items.length > 0) ? this.items[0].image : null;
    if (this.selected) this.findSelected();
  }

  // On component do check
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selected && changes.selected.previousValue && changes.selected.currentValue !== changes.selected.previousValue) {
      this.findSelected();
    } else this.selectFirst(changes);
  }

  ngAfterViewInit(): void {
    this.onItemInit.emit(this.items.find(item => item.text === this.itemSelected));
  }

  // Fill selected
  private findSelected(): void {
    for (let i = 0; i < this.items.length; i++){
      if (parseInt(this.items[i].key, 10) === parseInt(this.selected, 10) ||
        (this.selected !== null && this.selected.key !== undefined &&
        (parseInt(this.items[i].key, 10) === parseInt(this.selected.key, 10)
          || this.items[i].key === this.selected.key))
      ){
        this.itemSelected = (this.items && this.items.length > 0) ? this.items[i].text : null;
        this.itemImageSelected = (this.items && this.items.length > 0 && this.items[i].image) ? this.items[i].image : null;
        break;
      }
    }
  }

  // Select First Element
  private selectFirst(selected: SimpleChanges): void {
    if (this.items.length > 0 && selected.selected && selected.selected.currentValue) {
      this.items.filter(item => item.key === selected.selected.currentValue.key).map(result => {
        this.itemSelected = result.text;
      });
    } else if (this.selected) {
      this.items.filter(item => item.key === this.selected).map(result => {
        this.itemSelected = result.text;
      });
    }
  }

  // On element click
  public onClick(event): void {
    if (!this._eref.nativeElement.children[0].children[0].contains(event.target) && this.dropdownOpened) this.dropdownOpened = false;
  }

  // Selecting an item
  public itemSelect(item): void {
    this.itemSelected = item.text;
    this.itemImageSelected = item.image;
    this.onItemSelect.emit(item);
  }

  public onClickDropdown(): void {
    if (!this.disabled) {
      this.dropdownOpened = !this.dropdownOpened;
    }
  }

  public onMouseMove(e) {
    const tooltipSpan = document.getElementById('tooltip-' + e.target.id.split('-')[1] + '-' + this.id + '-' + this.random);

    const x = e.clientX;
    const y = e.clientY;
    tooltipSpan.style.top = (y + 20) + 'px';
    tooltipSpan.style.left = (x + 20) + 'px';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-select/dropdown-select.component.ts